<template>
  <div class="text">
    页面跳转中...
  </div>
</template>

<script>
import { getWxAuthLink } from '../../utils/share/api'
import { takeCoupon } from '../activity/api/activity-invite'

export default {
  name: 'shareBridge',
  computed: {
    cityId() {
      return this.$route.query.cityId
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 进行领劵（当别人点击你的分享链接，你就领了一张劵）
    requestTakeCoupon(params) {
      if (params.operateActivityId && params.activityId) {
        return takeCoupon(params)
      } else {
        return Promise.reject('缺少必要参数')
      }
    },
    init() {
      console.log('进入分享跳转页')
      const {
        redirectUrl,
        inviterUserId,
        cityId,
        operateActivityId,
        activityId,
        ...extra
      } = this.$route.query || {}
      if (redirectUrl && cityId) {
        const url = decodeURIComponent(redirectUrl)
        // 领劵
        this.requestTakeCoupon({
          cityId,
          userId: inviterUserId,
          operateActivityId,
          activityId,
          ...(extra || {})
        })
        // 微信授权
        getWxAuthLink({
          cityId,
          redirectUrl: url
        })
          .then(link => {
            window.location.href = link
          })
          .catch(err => {
            console.error('getWxAuthLink err:', err)
            this.jumpToHome()
          })
      } else {
        this.$toast('缺少必要参数')
        setTimeout(() => {
          this.jumpToHome()
        }, 1000)
      }
    },
    jumpToHome() {
      if (this.cityId) {
        console.error('缺少cityId!')
        return
      }
      this.$router.replace({
        name: 'Home',
        params: {
          cityId: this.cityId
        }
      })
    }
  }
}
</script>

<style scoped>
.text {
  display: block;
  position: fixed;
  top: 50%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, -50%);
  color: #999999;
}
</style>
